import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useShoppingCart } from '../../hooks/useShoppingCart'
import { useTheme } from '../../hooks/useTheme'

const CartIcon: React.FC = () => {
  const navigate = useNavigate()
  const { cart } = useShoppingCart()
  const { colors } = useTheme()

  const handleCartClick = () => {
    navigate('/carrito')
  }

  return (
    <button
      onClick={handleCartClick}
      className="relative p-2 hover:opacity-80 transition-opacity"
      title={`${cart.cantidad_espacios} item${cart.cantidad_espacios !== 1 ? 's' : ''} en el carrito`}
    >
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        style={{ color: colors.primary }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>

      {/* Badge con cantidad */}
      {cart.cantidad_espacios > 0 && (
        <div
          className="absolute -top-2 -right-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white rounded-full"
          style={{ backgroundColor: colors.primary }}
        >
          {cart.cantidad_espacios}
        </div>
      )}
    </button>
  )
}

export default CartIcon
